<template>
  <div>
    <div class="flex justify-between mb-7 border-b-2 border-gray-300">
      <h2 class="text-left font-black text-l text-skin-secondary">
        Cursos que te pueden interesar
      </h2>

      <p
        class="text-skin-pink font-bold cursor-pointer hidden md:block vertodos"
        @click="$router.push({ name: 'v2-categories', query:{q:''} })"
      >
        Ver todos
      </p>
    </div>

    <div
      class="
        lg:grid lg:grid-cols-3fr
        items-center
        md:grid-cols-miscursos_desktop
        1xl:grid-cols-explore_courses_desktop
        1xl:gap-36
        grid-cols-1fr
      "
    >
      <CourseCard
        :explore_card="true"
        v-for="(course, index) in GET_SUGGESTEDCOURSES.data"
        :key="index"
        :course="course"
        :name="course.name"
        :owner_name="course.propietary_name"
        :owner_lname="course.propietary_lastname"
        :users_in_course="course.users_in_course"
        :description="course.description"
        :parse_data="course.course_data"
        :image="course.image"
        :parse="true"
        class="mx-auto md:mx-0 mb-30"
        :source_id="course.id"
      />
    </div>

    <Pagination
      :current_page="currentPage + 1"
      :last_page="GET_SUGGESTEDCOURSES.last_page"
      @prev="prevpage"
      @next="nextpage"
      class="mb-30"
    />
  </div>
</template>

<script>
import Pagination from "../components/Pagination.vue";
import CourseCard from "../components/CourseCard.vue";
import { mapGetters } from "vuex";

export default {
  components: { Pagination, CourseCard },
  computed: {
    ...mapGetters("suggestedCourses", ["GET_SUGGESTEDCOURSES"]),
  },
  data() {
    return {
      currentPage: 0,
    };
  },
  mounted() {
    this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
      perPage: 4,
      currentPage: this.currentPage,
    });

    let x = window.matchMedia("(max-width: 450px)");
    if (x.matches) {
      this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
        perPage: 1,
        currentPage: this.currentPage,
      });
    }
  },
  methods: {
    nextpage() {
      if (this.currentPage < this.GET_SUGGESTEDCOURSES.last_page - 1) {
        this.currentPage = this.currentPage + 1;
        let nextpage = this.currentPage + 1;

        let x = window.matchMedia("(max-width: 450px)");
        if (x.matches) {
          this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
            perPage: 1,
            currentPage: nextpage,
          });
        } else {
          this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
            perPage: 4,
            currentPage: nextpage,
          });
        }
      }
    },
    prevpage() {
      if (this.currentPage > 0) {
        this.currentPage = this.currentPage - 1;
        let prevpage = this.currentPage - 1;

        let x = window.matchMedia("(max-width: 450px)");
        if (x.matches) {
          this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
            perPage: 1,
            currentPage: prevpage,
          });
        } else {
          this.$store.dispatch("suggestedCourses/get_suggestedCourses", {
            perPage: 4,
            currentPage: prevpage,
          });
        }
      }
    },
  },
};
</script>
